import { Pipe, PipeTransform } from '@angular/core';
import { format as formatDate, isValid } from 'date-fns';

@Pipe({
  name: 'eventEndTime'
})
export class EventEndTimePipe implements PipeTransform {
  transform(eventItem: any): string {
    try {
      const endDate = new Date(eventItem?.endDate);
      if (!eventItem.endDate || !isValid(endDate)) {
        return '';
      }

      const startDate = new Date(eventItem.startDate);
      if (!eventItem.startDate || !isValid(startDate)) {
        // If startDate is invalid, we can't compare, so just show end date/time
        const y_t = formatDate(new Date(), 'yyyy');
        const y_e = formatDate(endDate, 'yyyy');
        const format = (y_t === y_e) ? 'EEE, MMM d \'at\' h:mm aa' : 'EEE, MMM d, yyyy \'at\' h:mm aa';
        return formatDate(endDate, format);
      }

      const y_t = formatDate(new Date(), 'yyyy'); // Current year
      const y_e = formatDate(endDate, 'yyyy'); // Event end year
      const ymd_s = formatDate(startDate, 'yyyy-MM-dd'); // Start date
      const ymd_e = formatDate(endDate, 'yyyy-MM-dd'); // End date

      if (ymd_s === ymd_e) {
        // if start and end date are on same day, only show the end time...
        return formatDate(endDate, 'h:mm aa'); // Same day, only show end time
      } else {
        // ...otherwise, show the end date AND time.
        // but also include the year if end date is not in the current year
        const format = (y_t === y_e) ? 'EEE, MMM d \'at\' h:mm aa' : 'EEE, MMM d, yyyy \'at\' h:mm aa';
        return formatDate(endDate, format);
      }
    } catch (error: unknown) {
      console.error('Error in EventEndTimePipe:', error);
      return '';
    }
  }
}

